module.exports = "<hot-table [minSpareRows]=\"0\" [height]=\"600\" [manualColumnResize]=\"true\" [autoColumnSize]=\"true\" [startRows]=\"35\" [height]=\"600\" [rowHeaders]=\"rowHeaders\" [columns]=\"columns\" [data]=\"data\" hotId=\"CostHourTagDefinitions\">\n</hot-table>"


//////////////////
// WEBPACK FOOTER
// ./src/app/cost-hour-tag-definitions/cost-hour-tag-definitions.component.html
// module id = ./src/app/cost-hour-tag-definitions/cost-hour-tag-definitions.component.html
// module chunks = main